import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';
import htmlForFeature from 'utils/htmlForFeature';

export const HIGH_RISK_NETWORK_LAYER_ID = 'highRiskNetworkLayer';

const layerConfig = {
  title: 'High Risk Network',
};

function HighRiskNetworkLayer() {
  const dispatch = useDispatch();
  const { highRiskNetworkLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, highRiskNetworkLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (highRiskNetworkLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HIGH_RISK_NETWORK_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: highRiskNetworkLayer.visible,
      opacity: highRiskNetworkLayer.opacity,

      getLineColor: [230, 149, 0],
      lineWidthMinPixels: 3,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HIGH_RISK_NETWORK_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
            }),
          };
        }
      }
    });
  }
}

export default HighRiskNetworkLayer;
